import FormatValue from 'assets/components/formatValue/FormatValue';
import { getLocales } from 'assets/locales/Locale';
import { defaultDateFormat, defaultDateTimeFormat, localizeDate } from 'assets/utils/data/Date';
import { useAccountReceivableProvider } from '../../Finance.AccountReceivable.Hooks';

export default function FinanceAccountReceivableInfoGeneralInfo() {
  const { lang, translate } = getLocales();
  const { selected } = useAccountReceivableProvider();

  return (
    <>
      <h3>{lang.info}</h3>
      <div>
        {lang.dealer}: <b>{selected.dealerDisplayName || selected.dealer?.name || 'N/A'}</b>
      </div>
      {selected.statement && (
        <div>
          {lang.statement}: <b>{selected.statement?.statementNumber || selected.statementId || 'N/A'}</b>
        </div>
      )}
      <div>
        {lang.amount}:{' '}
        <b>
          <FormatValue value={`${(selected.amount || 0).toFixed(2)}$`} />
        </b>
      </div>
      <div>
        {lang.paymentMethod}: <b>{translate(selected.paymentMethodCode) || selected.paymentMethodCode || 'N/A'}</b>
      </div>
      <div>
        {lang.status}: <b>{translate(selected.statusCode) || 'N/A'}</b>
      </div>
      <div>
        {lang.createdAt}: <b>{localizeDate(selected.createdAtUtc, defaultDateTimeFormat)}</b>
      </div>
      <div>
        {lang.createdAtLocal}: <b>{localizeDate(selected.createdAtLocal, defaultDateTimeFormat)}</b>
      </div>
      <div>
        {lang.datePaymentReceived}: <b>{localizeDate(selected.paymentReceivedAtUtc, defaultDateFormat)}</b>
      </div>
      {selected.contactName && (
        <div>
          {lang.contactName}: <b>{selected.contactName || 'N/A'}</b>
        </div>
      )}
      {selected.contactEmail && (
        <div>
          {lang.contactEmail}: <b>{selected.contactEmail || 'N/A'}</b>
        </div>
      )}
      {selected.chequeNumber && (
        <div>
          {lang.chequeNumber}: <b>{selected.chequeNumber || 'N/A'}</b>
        </div>
      )}
      {selected.chequeDateAtUtc && (
        <div>
          {lang.chequeDate}: <b>{localizeDate(selected.chequeDateAtUtc, defaultDateFormat)}</b>
        </div>
      )}
      {selected.externalPaymentReference && (
        <div>
          {lang.externalPaymentReference}: <b>{selected.externalPaymentReference || 'N/A'}</b>
        </div>
      )}
      {selected.internalPaymentReference && (
        <div>
          {lang.internalPaymentReference}: <b>{selected.internalPaymentReference || 'N/A'}</b>
        </div>
      )}
      <div>
        {lang.evidenceSource}: <b>{selected.evidenceSource || 'N/A'}</b>
      </div>
      {selected.createdBy && (
        <div>
          {lang.createdBy}: <b>{selected.createdBy.fullName || lang.unknownUser}</b>
        </div>
      )}
      {selected.modifiedBy && (
        <div>
          {lang.modifiedBy}: <b>{selected.modifiedBy.fullName || lang.unknownUser}</b>
        </div>
      )}
    </>
  );
}
